export interface FooterProps {
  onDelete?: () => any
  onSubmit: () => any
  returnUrl: string
  isSubmitting: boolean
}
